import React, { useEffect, useState } from 'react';
import './Home.css';
import { CheckCircle, XCircle } from 'lucide-react';

import { Helmet } from 'react-helmet';

import imgContenidoDigital from '../assets/1_contenido_digital_home.jpeg';
import imgContenidoDigital_2 from '../assets/2_contenido_digital_home.jpg';
import imgContenidoDigital_3 from '../assets/3_contenido_digital_home_.png';
import imgContenidoDigital_4 from '../assets/4_contenido_digital_home.jpg';
import imgContenidoDigital_5 from '../assets/5_contenido_digital_home.png';
import img6 from '../assets/6_contenido_digital_home.jpg';
import img7 from '../assets/7_contenido_digital_home.jpg';
import img8 from '../assets/8_contenido_digital_home.jpg';
import img9 from '../assets/9_contenido_digital_home.jpg';
import img10 from '../assets/10_contenido_digital_home.jpg';
import img11 from '../assets/11_contenido_digital_home.jpg';
import img12 from '../assets/12_contenido_digital_home.jpg';
import img13 from '../assets/13_contenido_digital_home.jpg';
import img14 from '../assets/14_contenido_digital_home.jpg';
import img15 from '../assets/15_contenido_digital_home.jpg';
import img16 from '../assets/16_contenido_digital_home.jpg';
import img17 from '../assets/17_contenido_digital_home.jpg';
import imgContenidoDigital_6 from '../assets/18_contenido_digital_home.jpg';
import imgContenidoDigital_7 from '../assets/19_contenido_digital_home.jpg';
import imgDerecho from '../assets/img11_quienes_somos_contenido_digital.jpeg';
import imgMarketing from '../assets/img10_quienes_somos_contenido_digital.jpeg';
import imgTrigo from '../assets/img_trigo_contenido_digital.jpeg';
import imgBio from '../assets/img_bio_contenido_digital.jpg';
import videoImg from '../assets/boton_1_video_presentacion.jpg';
import videoImg1 from '../assets/boton2_video_2.jpeg';
import libroImg from '../assets/boton_2_contenido_digital_r.jpg';
import nuevaFotoHero from '../assets/nueva_foto_home_eduialogic_contenios_digitales.jpg';


const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const problemas = [
    "Producción lenta por parte de expertos y autores",
    "Software de autoría costoso y complejo",
    "Plataformas rígidas, poco intuitivas y sin atractivo visual",
    "Altos costos sin retorno inmediato",
    "Docentes con poco tiempo y recursos limitados",
    "Contenidos pesados que requieren alto ancho de banda",
    "Falta de personal con experiencia en tecnología educativa",
    "Material poco interactivo y desmotivador",
    "Contenido desactualizado y difícil de modificar",
    "SCORM exigido por norma, no por funcionalidad real"
  ];

  const soluciones = [
    "Producción ultrarrápida: cada Kit formativo se entrega en solo 10 días",
    "Sin software costoso: solo necesitas copiar y pegar un iframe",
    "Visualmente impactantes y funcionales",
    "Costo optimizado",
    "Docente sin carga extra",
    "Carga ligera",
    "Equipo de expertos en tecnología educativa",
    "Altamente interactivos",
    "Fácil de actualizar",
    "Libre de SCORM"
  ];

  const [videoSrc, setVideoSrc] = useState(null);


  useEffect(() => {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const src = isMobile
      ? '/video_contenido_digital_movil_celular.mp4'
      : '/1____video_1_contenido_digital.mp4';

    setVideoSrc(src + '?v=' + Date.now()); // Evitar cache
  }, []);


  return (
    <>
    <Helmet>
          <title>EduIALogic. Transformamos la educación digital en Colombia</title>
          <meta
            name="description"
            content="Virtualizamos contenidos educativos con pedagogía de calidad, tecnología ágil y producción de bajo costo para todos los niveles de formación."
          />
          <link rel="canonical" href="https://www.eduialogic.com/" />
    </Helmet>
    <section id="home" className="home-wrapper">
        <main className="home-content">
          {/* 🔹 SECCIÓN DEL VIDEO OCULTA */}
          {/* 
          <section className="video-hero">
            <br />
            {videoSrc && (
              <video
                className="background-video"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
              >
                <source src={videoSrc} type="video/mp4" />
                Tu navegador no soporta el video.
              </video>
            )}
            <div className="video-overlay"></div>
          </section>
          */}
          
          <section className="hero">
            <img 
              src={nuevaFotoHero} 
              alt="Eduialogic contenidos digitales" 
              className="hero-image"
            />
          </section>

          <br />


        <br />

        <section className="hero">

          

          <p className="parrafo-eduialogic_4">
          Virtualizamos contenidos educativos para todos los niveles de formación<br />
          desde la básica secundaria, educación continua, hasta pregrados, maestrías y doctorados.
          </p>

          <br />
          
          <p className="parrafo-eduialogic">
          EduIALogic es la única solución en Colombia que une pedagogía de calidad, tecnología ágil<br />
          y producción de bajo costo para transformar la educación digital.
          </p>
          

          <br />
          <p className="parrafo-eduialogic_4">
          Recursos que componen una asignatura digitalizada
          </p>
          <br />

          
          
          <div className="recursos-grid">
            {[
              { img: img6, titulo: '📄 Textos disciplinares'},
              { img: img7, titulo: '🎬 Videos educativos'},
              { img: img8, titulo: '📊 Gráficos y/o imágenes ilustrativas'},
              { img: img9, titulo: '🔗 Diagramas lógicos relacionales'},
              { img: img10, titulo: '🎧 Podcasts académicos'},
              { img: img11, titulo: '📚 Fuentes científicas curadas'},
              { img: img12, titulo: '🔤 Glosario técnico'},
              { img: img13, titulo: '❓ Preguntas reflexivas'},
              { img: img14, titulo: '💡 Actividades autoevaluativas'},
              { img: img15, titulo: '🛠️ Talleres de conexión con teoría'},
              { img: img16, titulo: '🗂️ Estudios de caso'},
              { img: img17, titulo: '🎮 Historias ramificadas'},
            ].map((item, index) => (
              <div className="recurso-item" key={index}>
                <img src={item.img} alt={item.titulo} />
                <h4>{item.titulo}</h4>
                <p>{item.detalle}</p>
              </div>
            ))}
          </div>
          <br />
          <br />


          <div className="imagen-contenido-digital">
            <img src={imgContenidoDigital} alt="Contenido Digital EduIALogic" />
          </div>

          <br />
          <br />
          
          <p className="parrafo-eduialogic_2">
          Con el respaldo del diseño instruccional de:
          </p>
          <br />
          <p className="parrafo-eduialogic_4">
          R-Learning 360°:<br />
          Una experiencia potente de aprendizaje virtual en 11 pasos
          </p>
          <br />

          <p className="parrafo-eduialogic_6">
          R-Learning 360° se trata de una experiencia potente de aprendizaje virtual, estructurada en 11 pasos,<br /> 
          que ofrece una solución pedagógica robusta, práctica y accesible en términos de costos.
          </p>
          <br />

           <p className="parrafo-eduialogic_6">
          Su propósito es claro: ayudar a las Instituciones de Educación Superior y a Colegios a expandir la educación virtual con calidad.
          </p>
          <br />

          <p className="parrafo-eduialogic_5">
          Quiero saber más de R-Learning 360º
          </p>
          
          <div className="ver-mas-container">

            {/* --- Bloque del video --- */}
            <div className="ver-mas-item">
              <a
                href="/4_Presentacion_contenidos_eduialogic.mp4"
                target="_blank"
                rel="noopener noreferrer"
                className="ver-mas-imagen-link"
              >
                <img src={videoImg} alt="Ver Video" className="ver-mas-imagen" />
              </a>
              <a
                href="/4_Presentacion_contenidos_eduialogic.mp4"
                target="_blank"
                rel="noopener noreferrer"
                className="ver-mas-boton"
              >
                Ver video explicativo
              </a>
            </div>

            {/* --- Bloque del PDF --- */}
            <div className="ver-mas-item">
              <a
                href="/R LEARNING REGISTRADO P2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="ver-mas-imagen-link"
              >
                <img src={libroImg} alt="Ver Documento" className="ver-mas-imagen" />
              </a>
              <a
                href="/R LEARNING REGISTRADO P2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="ver-mas-boton"
              >
                Ver documento PDF
              </a>
            </div>

          </div>




          <br />

          <div className="imagen-contenido-digital">
            <img src={imgContenidoDigital_2} alt="Contenido Digital EduIALogic" />
          </div>
          <br />
          <br />

          

          <p className="parrafo-eduialogic_4">
          Metodología: los 11 pasos del R-Learning 360°
          </p>

          <div className="metodologia-container">
            <div className="pasos-grid">
              {[
                { paso: 1, texto: '¡Dale play al comienzo!', icono: '🎬' },
                { paso: 2, texto: 'Descubre los contenidos disciplinares', icono: '📚' },
                { paso: 3, texto: 'Conecta ideas con el Diagrama Lógico', icono: '🧠' },
                { paso: 4, texto: 'Escucha para entender el panorama completo', icono: '🎧' },
                { paso: 5, texto: 'Profundiza con los expertos', icono: '🔍' },
                { paso: 6, texto: 'Habla el idioma de los profesionales', icono: '🗣️' },
                { paso: 7, texto: 'Rétate: piensa, pregunta, responde', icono: '🤔' },
                { paso: 8, texto: 'Pon a prueba lo que sabes', icono: '🧩' },
                { paso: 9, texto: 'Analiza y fundamenta', icono: '🛠️' },
                { paso: 10, texto: 'Aprende de la vida real', icono: '🕵️', claseExtra: 'paso-10' },
                { paso: 11, texto: 'Vive la experiencia decisiva', icono: '🔑', claseExtra: 'paso-11' },
              ].map(({ paso, texto, icono, claseExtra }, i) => (
                <div key={i} className={`paso-card ${claseExtra || ''}`}>
                  <span className="paso-numero">{icono} Paso {paso}</span>
                  <span className="paso-texto">{texto}</span>
                </div>
              ))}
            </div>
          </div>
          <br />
          <p className="parrafo-eduialogic_3">
          Un ciclo de repetición inteligente que transforma la educación digital<br />
          con calidad, economía y enfoque pedagógico.
          </p>
          <br />
          <div className="imagen-contenido-digital">
            <img src={imgContenidoDigital_3} alt="Contenido Digital EduIALogic" />
          </div>
          <br />
          <br />
          <br />
          <p className="parrafo-eduialogic_5">
          Conoce más en detalle de qué se trata cada uno de los 11 pasos del Modelo de Aprendizaje Virtual R-Learning 360<br /> 
          con el que digitalizamos los contenidos educativos
          </p>
          
          
         

          <div className="ver-mas-container">
            <a
              href="/VIDEO R LERNING PASOS DETALLADO.mp4"
              target="_blank"
              rel="noopener noreferrer"
              className="ver-mas-imagen-link"
            >
              <img
                src={videoImg1}
                alt="Ver Video"
                className="ver-mas-imagen"
              />
            </a>
            <a
              href="/VIDEO R LERNING PASOS DETALLADO.mp4"
              target="_blank"
              rel="noopener noreferrer"
              className="ver-mas-boton"
            >
              Ver video explicativo
            </a>
          </div>
          

          
          <br />
          <br />
          <p className="parrafo-eduialogic_7">
          "Revolucionamos la educación digital: ayudamos a las instituciones a crear contenidos ligeros, impactantes y accesibles que realmente transforman el aprendizaje."
          </p>
          <br />
          
          <div className="imagen-contenido-digital">
            <img src={imgContenidoDigital_4} alt="Contenido Digital EduIALogic" />
          </div>
          <br />
          <br />

          <p className="parrafo-eduialogic_4">
          Ventajas para las instituciones educativas<br />
          de nuestros contenidos educativos digitales
          </p>
          
        
          
          <div className="timeline-container">
            {[
              {
                numero: 1,
                lado: 'izquierda',
                titulo: 'Escalabilidad',
                descripcion: 'Nuestros contenidos educativos digitales son escalables a todos los niveles de formación desde básica primaria y básica secundaria hasta pregrados, maestrías y doctorados. Así como también educación no formal como cursos y diplomados.'
              },
              {
                numero: 2,
                lado: 'derecha',
                titulo: 'Calidad Respaldada',
                descripcion: (
                  <>
                    Nuestros contenidos educativos digitales tienen como referente los 8 estándares generales y 48 indicadores específicos de la Rúbrica de Calidad de Quality Matters (K‑12, Sexta Edición, 2025), la guía internacional más exigente en educación digital.
                    <br />
                    <a
                      href="https://gamma.app/docs/Rubrica-Quality-Matters-K12-2025-ES-fxj8qii2z8qxyqc?mode=doc"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                    >
                      Haz click aquí
                    </a>
                    <br />
                    Así mismo, tienen como referente los Estándares ISO/IEC 40180:2017, “Information technology – Quality for learning, education and training – Fundamentals and reference framework”, que actualiza y reemplaza las antiguas ISO/IEC 19796‑1:2005 (versión original internacional) e ISO/IEC 19796-3:2009 (adopción europea EN bajo el sistema CEN/CENELEC.) para la gestión de calidad en e-learning.  
                  </>
                )
              },
              {
                numero: 3,
                lado: 'izquierda',
                titulo: 'Diseño Instruccional sólido',
                descripcion: 'Nuestro modelo de diseño instruccional en 11 pasos ofrece una estructura pedagógica integral que asegura la alineación entre objetivos de aprendizaje, actividades, recursos y evaluación. Cada paso está cuidadosamente diseñado para promover la comprensión profunda, la retención significativa y la transferencia efectiva del conocimiento en entornos virtuales.'
              },
              {
                numero: 4,
                lado: 'derecha',
                titulo: 'Multiformato Educativo 100% Original y Libre de Copyright',
                descripcion: 'Nuestros contenidos educativos digitales están diseñados en múltiples formatos: texto, gráficos conceptuales, imágenes ilustrativas, video, audio e historias ramificadas, para facilitar los distintos estilos de aprendizaje de los estudiantes.'
              },
              {
                numero: 5,
                lado: 'izquierda',
                titulo: 'Analíticas de Seguimiento',
                descripcion: 'La plataforma que utilizamos incorpora un sistema de analíticas inteligentes que permite visualizar en tiempo real cómo los estudiantes interactúan con los contenidos educativos: número de vistas por sección, tiempo de permanencia y participación individual. Esta información ofrece a los docentes e instituciones una herramienta clave para realizar seguimiento pedagógico, ajustar estrategias didácticas y tomar decisiones basadas en datos reales que mejoran la experiencia de aprendizaje'
              },
              {
                numero: 6,
                lado: 'derecha',
                titulo: 'Integración Simple',
                descripcion: 'La integración de nuestros contenidos educativos digitales es fácil para la institución educativa: solo se necesita copiar y pegar un iframe o URL. También podemos entregar el contenido en SCORM. Nuestros contenidos educativos digitales son compatibles con cualquier LMS (Moodle, Canvas, Blackboard), intranet o sitio web en HTML.'
              },
              {
                numero: 7,
                lado: 'izquierda',
                titulo: '100% Original y Libre de conflictos de Copyright',
                descripcion: 'Cada recurso es creado desde cero por nuestro equipo de tecnopedagogos y creativos, con base en fuentes académicas, científicas y literarias debidamente curadas y referenciadas, sin recurrir a licencias Creative Commons ni reutilizar materiales de terceros. Esto garantiza que todo el material sea original, exclusivo y libre de conflictos de copyright.'
              },
              {
                numero: 8,
                lado: 'derecha',
                titulo: 'Contenidos Actualizables',
                descripcion: 'Todos los contenidos son actualizables y personalizables. Una primera opción es que EduIALogic  brinde el soporte de actualización o que la Institución educativa adquiera la licencia de la plataforma para realizar ajustes cuando lo necesite, sin depender de nosotros.'
              },
              {
                numero: 9,
                lado: 'izquierda',
                titulo: 'Experiencia Intuitiva',
                descripcion: 'Nuestra plataforma ofrece navegación fluida y experiencia sin interrupciones. Nuestros contenidos educativos digitales funcionan como si fueran nativos en cualquier LMS .'
              },
              {
                numero: 10,
                lado: 'derecha',
                titulo: 'Costo Optimizado y Producción Ágil. ',
                descripcion: 'Ofrecemos una producción ágil y eficiente, en tiempo récord, con costos accesibles que se ajustan a los presupuestos reales de las instituciones educativas.'
              },
              {
                numero: 11,
                lado: 'izquierda',
                titulo: 'Contenidos Optimizados y Responsivos',
                descripcion: 'Nuestros contenidos educativos digitales funcionan con bajo ancho de banda, accesibles desde cualquier dispositivo: computador, tableta o celular.'
              }
            ].map((item, i) => (
              <div key={i} className={`timeline-item ${item.lado}`}>
                <div className="timeline-content">
                  <div className="timeline-circle">{item.numero}</div>
                  <h3>{item.titulo}</h3>
                  <p>{item.descripcion}</p>
                </div>
              </div>
            ))}
          </div>

          
          <br />

          
          <div className="imagen-contenido-digital">
            <img src={imgContenidoDigital_5} alt="Contenido Digital EduIALogic" />
          </div>
          <br />
          <p className="parrafo-eduialogic_7">
          "Contenidos educativos digitales de alta calidad pedagógica: enseñan de verdad,<br /> 
          inspiran al estudiante y optimizan tu inversión."
          </p>
          
          <br />
          <br />

          
          
          
          
          <p className="parrafo-eduialogic_2">
          El Modelo R-Learning 360° lidera la innovación educativa en Colombia,<br /> 
          integrando la oferta más completa de recursos tecnopedagógicos del mercado.
          </p>
          <br />
          <br />

          <p className="parrafo-eduialogic_4">
          ¿Qué aporta la Institución Educativa para iniciar<br />
          el proceso de digitalización de una asignatura?
          </p>
          <br />
          
          
          <p className="parrafo-eduialogic_6">
           La Institución Educativa solo debe proporcionar la Guía de Contenidos de la asignatura en el siguiente formato.
          </p>
          <br />

          <div className="bloque-descarga-formato_1">
            <a
              href="https://www.eduialogic.com/GUIA_DE_CONTENIDOS_DE_ASIGNATURA_O_DE_CURSO_DE_EDUCACION_CONTINUA.docx"
              target="_blank"
              rel="noopener noreferrer"
            >
              📥 Puedes descargar el formato aquí
            </a>
          </div>

          <br />
          <br />
          
          <p className="parrafo-eduialogic_6">
           La Institución Educativa deberá proporcionar a EduIALogic acceso a las bases digitales de su propiedad,<br /> 
           en las cuales se encuentre bibliografía directamente relacionada con la asignatura o curso objeto de virtualización.
          </p>
          <br />

          <p></p>
          <div className="imagen-contenido-digital">
            <img src={imgContenidoDigital_7} alt="Contenido Digital EduIALogic" />
          </div>
          <br />
          <br />
          <p className="parrafo-eduialogic_4">
          Así se ve una asignatura R-Learning 360°
          </p>

          <p className="parrafo-eduialogic_6">
           ¿Quieres conocer un ejemplo completo de una asignatura digitalizada bajo nuestro modelo?
          </p>
          
          <p className="parrafo-eduialogic_6">
           Pues aquí la tienes para que navegues todos los contenidos
          </p>
          <br />
          
          <div className="grid-cursos_1">
            <div className="curso-card_1">
              <img src={imgDerecho} alt="Derecho Penal" className="curso-img_1" />
              <h3>Derecho Penal</h3>
              <p>Asignatura de pregrado</p>
              <a
                href="https://gamma.app/docs/Derecho-Penal-General-l30reok9jr95d33"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgMarketing} alt="Marketing Digital" className="curso-img" />
              <h3>Fundamentos del Marketing Digital</h3>
              <p>Asignatura de Maestría o de especialización</p>
              <a
                href="https://gamma.app/docs/Fundamentos-del-Marketing-Digital-th1wmg9rybb69a5"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgTrigo} alt="Trigonometría" className="curso-img_1" />
              <h3>Geometría y Trigonometría</h3>
              <p>Asignatura de grado 11 de Bachillerato</p>
              <a
                href="https://gamma.app/docs/GEOMETRIA-Y-TRIGONOMETRIA-zwd7scg8rs6d77a"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgBio} alt="Biología" className="curso-img_1" />
              <h3>Biología</h3>
              <p>Asignatura de grado quinto de Primaria</p>
              <a
                href="https://gamma.app/docs/BIOLOGIA-rahfqgx8u8tvcw7"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>
          </div>
          <br />
          <br />
          <p className="parrafo-eduialogic_12">
          “Educación digital con sentido: contenidos que transforman, inspiran y cuestan menos.”
          </p>
          <br />
        </section>
      </main>
    </section>
    </>
  );
};

export default Home;
